import {useAuth} from "react-oidc-context";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from "@mui/material/Box";
import {FactoryOutlined, Home} from "@mui/icons-material";
import {List, ListItem, ListItemButton, ListItemIcon, ListItemText} from "@mui/material";
import {UserMenu} from "./UserMenu";
import {useNavigate, useLocation} from "react-router-dom";
import {isUserGaiaXStaff, isUserTokenManager} from "../util/auth.utils";
import {useEffect, useState} from "react";

export const Header = () => {
    const auth = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const isCompanies = location.pathname === '/companies'
    const isMyCompanies = location.pathname === '/my-companies'
    const [isGaiaXStaff, setIsGaiaXStaff] = useState<boolean>(false);
    const [isTokenManager, setIsTokenManager] = useState<boolean>(false);

    useEffect(() => {
        if (auth.isAuthenticated) {
            setIsGaiaXStaff(isUserGaiaXStaff(auth.user))
            setIsTokenManager(isUserTokenManager(auth.user))
        }
    }, [auth.isAuthenticated, auth.user])

    return (
        <Box sx={{flexGrow: 1, display: "flex"}} mb={'1em'}>
            <AppBar position="static">
                <Toolbar>
                    <Box>
                        <List>
                            <ListItem sx={{justifySelf: 'flex-start'}} component="nav">
                                <ListItemButton onClick={() => navigate('/')}>
                                    <ListItemIcon>
                                        <Home sx={{color: 'white'}}/>
                                    </ListItemIcon>
                                </ListItemButton>
                                {isGaiaXStaff && <>
                                    <ListItemButton component="a" disabled={!isGaiaXStaff} selected={isCompanies}
                                                    onClick={() => navigate('/companies')}>
                                        <ListItemIcon sx={{color: 'white'}}>
                                            <FactoryOutlined/>
                                        </ListItemIcon>
                                        <ListItemText primary="Companies"/>
                                    </ListItemButton>
                                </>}
                                {isTokenManager &&
                                    <>
                                        <ListItemButton component="a" disabled={!isTokenManager} selected={isMyCompanies}
                                                        onClick={() => navigate('/my-companies')}>
                                            <ListItemIcon sx={{color: 'white'}}>
                                                <FactoryOutlined/>
                                            </ListItemIcon>
                                            <ListItemText primary="My companies"/>
                                        </ListItemButton>
                                    </>
                                }
                            </ListItem>
                        </List>
                    </Box>
                    <Box sx={{flexGrow: 1}}></Box>
                    <UserMenu></UserMenu>
                </Toolbar>
            </AppBar>
        </Box>
    )
}